import Color from 'color'
import { rgbToHex } from '@material-ui/core/styles'
import { ISettingsFormValues } from '../../../containers/Form/Settings/SettingsForm'
import { toAHEX } from '../../../utils/ColorTransformator'
import { EventStatus } from '../../Event'
import { colors } from '../../Event/eventConfig'
import serialize from '../../../utils/serialize'

export enum IRequestCustomStatus {
  NoPayment = '0',
  Advance = '1',
  Full = '2',
  Unavailable = '4',
  Canceled = '3',
}

export default function(item: ISettingsFormValues, id: number): IRequestBody {
  return {
    /* eslint-disable @typescript-eslint/camelcase */
    cancel_free: item.cancelFree,
    cancel_pay: item.cancelPay,
    custom_reservation_status_colors: {
      [IRequestCustomStatus.NoPayment]:
        rgbToHex(Color(item.noPaymentCustomColor).toString()) ===
        colors.get(EventStatus.NoPayment)
          ? '#0'
          : toAHEX(Color(item.noPaymentCustomColor)),
      [IRequestCustomStatus.Advance]:
        rgbToHex(Color(item.advanceCustomColor).toString()) ===
        colors.get(EventStatus.Advance)
          ? '#0'
          : toAHEX(Color(item.advanceCustomColor)),
      [IRequestCustomStatus.Full]:
        rgbToHex(Color(item.fullPaymentCustomColor).toString()) ===
        colors.get(EventStatus.Full)
          ? '#0'
          : toAHEX(Color(item.fullPaymentCustomColor)),
      [IRequestCustomStatus.Canceled]:
        rgbToHex(Color(item.canceledCustomColor).toString()) ===
        colors.get(EventStatus.Canceled)
          ? '#0'
          : toAHEX(Color(item.canceledCustomColor)),
      [IRequestCustomStatus.Unavailable]:
        rgbToHex(Color(item.noAvailableCustomColor).toString()) ===
        colors.get(EventStatus.Unavailable)
          ? '#0'
          : toAHEX(Color(item.noAvailableCustomColor)),
    },
    custom_reservation_status_names: {
      [IRequestCustomStatus.NoPayment]: item.noPaymentCustomLabel,
      [IRequestCustomStatus.Advance]: item.advanceCustomLabel,
      [IRequestCustomStatus.Full]: item.fullPaymentCustomLabel,
      [IRequestCustomStatus.Unavailable]: item.noAvailableCustomLabel,
      [IRequestCustomStatus.Canceled]: item.canceledCustomLabel,
    },
    daynightFrom: item.daynightFrom,
    daynightTo: item.daynightTo,
    default_reservation_status: item.reservationStatus,
    default_service: item.feedingType,
    id: String(id),
    prepayment_type: String(item.prepaidType),
    provision: item.provision ? serialize(item.provision) : undefined,
    reservation_appearance: item.eventShape === 'square' ? '1' : '0',
    show_busy_terms: item.show_busy_terms ? '1' : '0',
    reservation_appearance_label: item.eventLabel.split(' '),
    room_service_bedding: item.serviceBeddingCheck
      ? String(item.serviceBedding)
      : '0',
    room_service_bedding_days: item.serviceBeddingCheck
      ? JSON.stringify(item.serviceBeddingDays.map(v => Number(v)))
      : '',
    room_service_bedding_status: item.serviceBeddingCheck
      ? String(item.serviceBeddingStatus)
      : '0',
    room_service_cleaning: item.serviceCleaningCheck
      ? String(item.serviceCleaning)
      : '0',
    room_service_cleaning_days: item.serviceCleaningCheck
      ? JSON.stringify(item.serviceCleaningDays.map(v => Number(v)))
      : '',
    room_service_cleaning_status: item.serviceCleaningCheck
      ? String(item.serviceCleaningStatus)
      : '0',
    room_service_towels: item.serviceTowelsCheck
      ? String(item.serviceTowels)
      : '0',
    room_service_towels_days: item.serviceTowelsCheck
      ? JSON.stringify(item.serviceTowelsDays.map(v => Number(v)))
      : '',
    room_service_towels_status: item.serviceTowelsCheck
      ? String(item.serviceTowelsStatus)
      : '0',
    show_summary_checks: item.summaryCheckInOut ? '1' : '0',
    show_summary_food: item.summaryFeeding ? '1' : '0',
    show_summary_persons: item.summaryFulfillment ? '1' : '0',
    send_mail_reservation: item.send_mail_reservation,
    send_mail_client_reservation: item.send_mail_client_reservation,
    /* eslint-enable */
  }
}

interface ICustomReservationStatus {
  [IRequestCustomStatus.NoPayment]: string
  [IRequestCustomStatus.Advance]: string
  [IRequestCustomStatus.Full]: string
  [IRequestCustomStatus.Canceled]: string
  [IRequestCustomStatus.Unavailable]: string
}

export interface IRequestBody {
  id: string
  cancel_free?: string
  show_busy_terms: string
  cancel_pay?: string
  default_service?: string
  prepayment_type?: string
  default_reservation_status?: string
  show_summary_food?: '0' | '1'
  show_summary_persons?: '0' | '1'
  show_summary_checks?: '0' | '1'
  reservation_appearance?: '0' | '1'
  reservation_appearance_label?: string[]
  custom_reservation_status_colors?: ICustomReservationStatus
  daynightTo: string
  daynightFrom: string
  provision: any
  custom_reservation_status_names?: ICustomReservationStatus
  room_service_cleaning: string
  room_service_bedding: string
  room_service_towels: string
  room_service_cleaning_status: string
  room_service_bedding_status: string
  room_service_towels_status: string
  room_service_cleaning_days: string
  room_service_bedding_days: string
  room_service_towels_days: string
  send_mail_client_reservation?: string
  send_mail_reservation?: string
}
